import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, KEY_ARROW_DOWN } from '@/constants';
import { usePopupOpen } from '@/hooks';
import { switchNextSectionByArrowThunk } from '@/actions';
import { isActiveElementEditable } from '@/helpers';

export default () => {
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();

  useEffect(() => {
    if (isSomePopupOpen) {
      removeListener();
    } else {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      removeListener();
    };
  });

  const removeListener = () => {
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = event => {
    if (!isActiveElementEditable()) {
      if ([KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, KEY_ARROW_DOWN].includes(event.code)) {
        event.preventDefault();
        dispatch(switchNextSectionByArrowThunk(event.code));
      }
    }
  };
};
